const STORAGE_KEY = 'suarte:likeState';

const isBrowser = typeof window !== 'undefined';

const safeReadStore = () => {
  if (!isBrowser) return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const safeWriteStore = (store) => {
  if (!isBrowser) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota errors */
  }
};

export const persistLikeState = (postId, state) => {
  if (!postId || !state) return;
  const { isLiked, likeCount } = state;
  const store = safeReadStore();
  store[String(postId)] = {
    isLiked: !!isLiked,
    likeCount: typeof likeCount === 'number' ? likeCount : 0,
    savedAt: Date.now(),
  };
  safeWriteStore(store);
};

export const getPersistedLikeState = (postId) => {
  if (!postId) return null;
  const store = safeReadStore();
  return store[String(postId)] || null;
};
